import React, {useContext, useEffect, useState, useRef} from "react";
import InfoIcon from "../Assets/Images/info-icon.svg";
import InfoIconSelected from "../Assets/Images/info-icon-selected.svg";
import {DataContext} from "../Context/DataContext";

export default function Variable({axisID, id, content = "", description = "", options = []}) {
	const {requestVariables, setRequestVariables} = useContext(DataContext);
	const [selected, setSelected] = useState(false);
	const [displayDescription, setDisplayDescription] = useState(false);

	let isOptionsVariable = options.length !== 0;
	const [displayOptions, setDisplayOptions] = useState(false);
	const [optionValue, setOptionValue] = useState("----------");

	const clickToVariable = () => {
		// Prevents the "Minimis" variable from being deselected
		if (id === "Minimis" && selected) return;

		// It is an option variable
		if (isOptionsVariable) {
			setDisplayOptions(!displayOptions);
		}
		// It is a variable that is either chosen or not
		else {
			if (id === undefined) return;
			let newRequestVariables = requestVariables;
			let indexInRequest = newRequestVariables[axisID].indexOf(id);
			if (selected) newRequestVariables[axisID].splice(indexInRequest, 1);
			else newRequestVariables[axisID].push(id);
			setRequestVariables(newRequestVariables);
			setSelected(!selected);
		}
	};

	// Show or hide description

	const showDescription = () => {
		setDisplayDescription(true);
	};

	const hideDescription = () => {
		setDisplayDescription(false);
	};

	// Set the value of the variable (if this is an option variable)

	const chooseOptionValue = (option) => {
		setOptionValue(option.content);
		setDisplayOptions(false);
		setSelected(option.id !== "none");

		let newRequestVariables = requestVariables;
		for (let i = 0; i < options.length; i++) {
			let optionIndex = newRequestVariables[axisID].indexOf(options[i].id);
			if (optionIndex >= 0) newRequestVariables[axisID].splice(optionIndex, 1);
		}

		if (option.id !== "none") newRequestVariables[axisID].push(option.id);
		setRequestVariables(newRequestVariables);
	};

	// Initialize the variable "Minimis"

	useEffect(() => {
		if (id === "Minimis") clickToVariable();
	});

	// Click outside the variable to hide dropdown menu

	const useClickOutside = (ref) => {
		useEffect(() => {
			const handleClickOutside = (event) => {
				if (ref.current && !ref.current.contains(event.target)) {
					setDisplayOptions(false);
				}
			}
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			}
		}, [ref]);
	}

	const variableRef = useRef(null);
	useClickOutside(variableRef);
	

	return (
		<button
			className='variable'
			onClick={clickToVariable}
			ref={variableRef}
			style={{
				backgroundColor: selected ? "var(--blue)" : "var(--gray-0)",
				borderRadius: displayOptions ? "15px 15px 0 0" : "15px",
				boxShadow: displayOptions ? "var(--box-shadow-options)" : "none",
				color: selected ? "var(--white)" : "var(--blue)",
			}}>
			{isOptionsVariable ? (
				<div>
					<p className='var-content'>{content}</p>
					<p className='var-option'>{optionValue}</p>
				</div>
			) : (
				<p className='var-content'>{content}</p>
			)}
			<div className='var-info' style={{display: description === "" ? "none" : "block"}} onMouseEnter={showDescription} onMouseLeave={hideDescription} onClick={(e) => e.stopPropagation()}>
				<img src={selected ? InfoIconSelected : InfoIcon} alt='Detalles sobre la variable'></img>
				<p style={{display: displayDescription ? "block" : "none"}}>{description}</p>
			</div>
			<ul className='var-options-list' style={{display: displayOptions ? "block" : "none"}}>
				{options.map((option) => (
					<li onClick={() => chooseOptionValue(option)}>{option.content}</li>
				))}
				<li onClick={() => chooseOptionValue({id:"none", content:"----------"})}>No seleccionar</li>
			</ul>
		</button>
	);
}
